import chroma from 'chroma-js';

export default function (value) {
  const valuePct = value / 24;

  const colorScale = chroma.scale(['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256']);

  if (value > 24) {
    return '#d7301f';
  } return colorScale(valuePct).toString();
}
